import { timelineEvents } from '@/mocks/homeData';

export default function TimelineSection() {
  return (
    <section id="timeline" className="px-4 md:px-8 pt-16 md:pt-28">
      <div className="mx-auto max-w-6xl">
        <div className="rounded-lg border border-background-200 bg-background-100 px-4 md:px-10 py-10 md:py-14">
          <div className="max-w-2xl">
            <span className="text-xs tracking-[0.25em] text-primary-600">事件时间线</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              按节点复盘全程
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              从首个素材流出到讨论回落，六个阶段逐环标注，每一环都对应可查证的时间点。
            </p>
          </div>

          <ol className="mt-10 md:mt-14 relative">
            <span className="absolute left-[15px] md:left-1/2 top-2 bottom-2 w-px bg-background-300 md:-translate-x-px hidden md:block" />
            <span className="absolute left-[15px] top-2 bottom-2 w-px bg-background-300 md:hidden" />

            {timelineEvents.map((event, index) => {
              const rightSide = index % 2 === 1;
              return (
                <li
                  key={event.title}
                  className="relative flex gap-5 md:gap-0 pb-8 last:pb-0 md:min-h-[104px]"
                >
                  <span className="relative z-10 flex md:hidden items-center justify-center w-8 h-8 shrink-0 rounded-full bg-accent-500 text-accent-950 font-heading text-xs font-bold">
                    {index + 1}
                  </span>

                  <div
                    className={`hidden md:flex ${
                      rightSide
                        ? 'md:order-2 md:w-1/2 md:pl-12'
                        : 'md:order-1 md:w-1/2 md:pr-12 md:text-right'
                    }`}
                  >
                    <div className="w-full rounded-lg border border-background-200 bg-background-50 p-5">
                      <div
                        className={`flex items-center gap-2 ${
                          rightSide ? '' : 'md:flex-row-reverse'
                        }`}
                      >
                        <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-900 text-[11px]">
                          {event.phase}
                        </span>
                        <span className="text-xs text-foreground-500">{event.time}</span>
                      </div>
                      <h3 className="mt-2.5 font-heading text-base font-bold text-foreground-950">
                        {event.title}
                      </h3>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                        {event.desc}
                      </p>
                    </div>
                  </div>

                  <span className="hidden md:flex md:order-1 md:absolute md:left-1/2 md:-translate-x-1/2 md:top-4 items-center justify-center w-6 h-6 rounded-full border-2 border-accent-500 bg-background-50">
                    <span className="w-2 h-2 rounded-full bg-accent-500" />
                  </span>

                  <div className="flex-1 md:hidden">
                    <div className="flex items-center gap-2">
                      <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-900 text-[11px]">
                        {event.phase}
                      </span>
                      <span className="text-xs text-foreground-500">{event.time}</span>
                    </div>
                    <h3 className="mt-2 font-heading text-base font-bold text-foreground-950">
                      {event.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                      {event.desc}
                    </p>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}